import React, { createContext, useContext } from 'react'

import {
  useNutrimaticMarketHub,
  type NutrimaticMarketHub,
} from './useNutrimaticMarketHub'

const NutrimaticMarketContext = createContext<NutrimaticMarketHub | null>(null)

/**
 * Hub Nutrimatic app-wide (vitrina + catálogo de instrumentos).
 * `catalog.instruments` alimenta el catálogo operativo (`useOperativeTokenCatalog`);
 * la ejecución swap/LP sigue fuera de este provider.
 */
export function NutrimaticMarketProvider({ children }: { children: React.ReactNode }) {
  const hub = useNutrimaticMarketHub()
  return (
    <NutrimaticMarketContext.Provider value={hub}>{children}</NutrimaticMarketContext.Provider>
  )
}

export function useNutrimaticMarket(): NutrimaticMarketHub {
  const ctx = useContext(NutrimaticMarketContext)
  if (!ctx) {
    throw new Error('useNutrimaticMarket must be used within NutrimaticMarketProvider')
  }
  return ctx
}

/** Optional access when a surface may render outside the provider (tests). */
export function useNutrimaticMarketOptional(): NutrimaticMarketHub | null {
  return useContext(NutrimaticMarketContext)
}
